/**
 * Router.
 *
 * @module app/controllers/Router
 */
import * as Routing from './Routing';
import Translator from '../components/Translator';

/* Hooks allow functions to 'clear up' when an ajax with a URL change (aka fragment) is requested
   Primarily this is to deregister from subscriptions, stop setTimeouts and other async runners
   Given a hook may run twice, you should ensure that it doesn't throw the second time it is executed.
   You can verify this by loading two fragments in succession.
*/

var hooks = [];

var initTranslations = function () {

    var oldGetFragment = Routing.history.getFragment;
    var oldLoadUrl = Routing.history.loadUrl;

    var getFragmentTo = function (fragment, forcePushState) {

        var ret = oldGetFragment.call(this, fragment, forcePushState);

        return Translator.translateUrl(ret, 'to');
    };

    var getFragmentFrom = function (fragment, forcePushState) {

        var ret = oldGetFragment.call(this, fragment, forcePushState);

        return Translator.translateUrl(ret, 'from');
    };

    Routing.history.getFragment = getFragmentFrom;

    Routing.history.loadUrl = function loadUrl(fragment) {

        var prevGetFragment = Routing.history.getFragment;

        Routing.history.getFragment = getFragmentTo;
        oldLoadUrl.call(this, fragment);
        Routing.history.getFragment = prevGetFragment;
    };
};

var api = {

    /**
     * Backbone Router
     *
     * @type    {Object}
     *
     * @private
     */
    router: new Routing.Router(),

    /**
     * Router hooks to clear async operations on fragment load
     *
     * @type {Object}
     *
     * @public
     */
    hooks: {

        /**
         * Pushes a function hook into the pool.
         *
         * @param {function} A function to call before the new fragment is rendered.
         * @returns {void}
         *
         * @public
         */
        add: function (hook) {

            hooks.push(hook);
        },

        /**
         * Executes hooks after ajax has returned data
         *
         * @returns {void}
         *
         * @public
         */
        exec: function () {

            return hooks.map(function (hook) {

                return hook();
            });
        },
    },


    /**
     * Starts the router
     *
     * @returns {void}
     *
     * @private
     */
    start: function () {

        initTranslations();

        Routing.history.start();

        api.router.started = true;
    },
};

export default api;
